export default "__VITE_ASSET__BVgds1Qg__"